export default [
  {
    path: '/arquivos-dados',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'RPA',
        path: 'rpa',
        component: () => import('@/views/arquivosDados/rpa/Index.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'RPA (Robô)' }]
        }
      },
      {
        name: 'Envio de Arquivos de Dados',
        path: '',
        component: () => import('@/views/arquivosDados/index/Index.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'Envio de Arquivos de Dados' }]
        }
      },
      {
        name: 'Arquivos Tratados',
        path: 'arquivos-tratados',
        component: () => import('@/views/arquivosDados/index/ArquivosTratadosIndex.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'Envio de Arquivos de Dados' }]
        }
      }
    ]
  }
];
